const AGREEMENTS_REGULATIONS_SET = 'AGREEMENTS_REGULATIONS_SET';
const AGREEMENTS_REGULATIONS_SET_VALIDATION_MESSAGE = 'AGREEMENTS_REGULATIONS_SET_VALIDATION_MESSAGE';
const AGREEMENTS_REGULATIONS_CHANGE = 'AGREEMENTS_REGULATIONS_CHANGE';

const accountFormRegulationsSet = (checked) => ({
  type: AGREEMENTS_REGULATIONS_SET,
  payload: {
    checked
  }
});

const accountFormRegulationsSetValidationMessage = (validationMessage) => ({
  type: AGREEMENTS_REGULATIONS_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const accountFormRegulationsChange = (checked, validationMessage) => ({
  type: AGREEMENTS_REGULATIONS_CHANGE,
  payload: {
    checked,
    validationMessage
  }
});

export {
  accountFormRegulationsSetValidationMessage,
  accountFormRegulationsSet,
  accountFormRegulationsChange,
  AGREEMENTS_REGULATIONS_CHANGE,
  AGREEMENTS_REGULATIONS_SET_VALIDATION_MESSAGE,
  AGREEMENTS_REGULATIONS_SET
};

